import { lazy } from 'react';
import { RouteConfig } from './types/routes';

const HomePage = lazy(() => import('src/pages/home'));
const MetricsPage = lazy(() => import('src/pages/metrics'));
const BalancePage = lazy(() => import('src/pages/balance'));
const NotFoundPage = lazy(() => import('src/pages/not-found'));
const CreateCampaign = lazy(() => import('src/pages/campaign/create'));
const ViewCampaign = lazy(() => import('src/pages/campaign/view'));
const CampaignList = lazy(() => import('src/pages/campaign/list'));

// Chope CRM pages (with route guard inside)
const ChopeRootRedirect = lazy(() => import('src/pages/chope/ChopeRootRedirect'));
const ChopeListPageWithGuard = lazy(() => import('src/pages/chope/list'));
const ChopeCreatePageWithGuard = lazy(() => import('src/pages/chope/create'));
const ChopeDetailPageWithGuard = lazy(() => import('src/pages/chope/detail'));

export const routesConfig: RouteConfig[] = [
  {
    path: '/',
    element: HomePage,
    meta: {},
  },
  {
    path: '/metrics',
    element: MetricsPage,
    meta: {},
  },
  {
    path: '/balance',
    element: BalancePage,
    meta: {},
  },
  {
    path: '/campaign/list',
    element: CampaignList,
    meta: {},
  },
  {
    path: '/campaign/create/:step?',
    element: CreateCampaign,
    meta: { isSidebarHidden: true },
  },
  {
    path: '/campaign/:id/:step?',
    element: ViewCampaign,
    meta: { isSidebarHidden: true },
  },
  // Chope CRM routes - sidebar visibility determined by ?entry=deeplink (hide when present)
  {
    path: '/chope',
    element: ChopeRootRedirect,
    meta: { isChopeRoute: true },
  },
  {
    path: '/chope/campaign/list',
    element: ChopeListPageWithGuard,
    meta: { isChopeRoute: true },
  },
  {
    // Creation is a focused flow, so the sidebar stays hidden regardless of entry point
    path: '/chope/campaign/create/:step?',
    element: ChopeCreatePageWithGuard,
    meta: { isChopeRoute: true, isSidebarHidden: true },
  },
  {
    path: '/chope/campaign/detail/:id',
    element: ChopeDetailPageWithGuard,
    meta: { isChopeRoute: true },
  },
  {
    path: '*',
    element: NotFoundPage,
    meta: { isSidebarHidden: true },
  },
];
